// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2LjNw","buttons":"PendingPaymentAlert_buttons__3aAJ3"};